import React from 'react';
import './About.css';

function About() {
  return (
    <main className="about-page">
      <h1 className="about-title">À PROPOS</h1>

      <section className="about-intro">
        <div className="about-box">
          <p>
            <strong>ETOILE BRICOLAGE</strong> est le partenaire idéal pour votre rayon de quincaillerie.
          </p>
          <p>
            Notre force repose sur notre expertise métier, portée par une équipe technique expérimentée garantissant la 
            conception, la réalisation et le service après-vente. Notre gamme de produits répond aux exigences de qualité les plus élevées du marché.
          </p>
          <p>
            Nous vous proposons un délai de livraison très court, ainsi que des conseils techniques adaptés à vos besoins.
          </p>
          <p>
            Soucieux de la qualité, nous sélectionnons les meilleurs produits avec le meilleur rapport qualité-prix.
          </p>
          <p>
            <strong>Votre partenaire de confiance</strong> pour tous vos projets de bricolage, rénovation et construction.
          </p>
        </div>
      </section>

      <section className="about-values">
        <h2>ETOILE BRICOLAGE, découvrez nos valeurs :</h2>

        <div className="value-item">
          <h3>QUALITÉ</h3>
          <p>
            La qualité de nos produits est au cœur de nos priorités. Chaque article que nous proposons est rigoureusement 
            sélectionné pour répondre aux normes les plus élevées en termes de durabilité, performance et sécurité.
          </p>
        </div>

        <div className="value-item">
          <h3>VARIÉTÉ</h3>
          <p>
            Notre quincaillerie se distingue par une large variété de produits soigneusement sélectionnés 
            pour répondre à tous vos besoins. Nous nous engageons à offrir des produits adaptés à chaque usage.
          </p>
        </div>

        <div className="value-item">
          <h3>CRÉATIVITÉ</h3>
          <p>
            Créons ensemble des solutions innovantes pour donner vie à vos projets ! Nos produits et designs 
            stimulent votre imagination pour créer des espaces uniques.
          </p>
        </div>
      </section>
    </main>
  );
}

export default About;
